import { Edit, SimpleForm, TextInput } from 'react-admin';

export const CategoryEdit = () => (
  <Edit redirect="list">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" />
    </SimpleForm>
  </Edit>
);
